import { action } from 'satcheljs/lib/legacy';
export default action('setIsSending')(function setIsSending(viewState, isSending) {
    viewState.isSending = isSending;
});
//# sourceMappingURL=setIsSending.js.map